import { writable } from 'svelte/store';

const selectedTags = writable([]);

export default selectedTags;
